import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { render } from "react-dom";
import Auth from "./auth";
// import decode from 'jwt-decode';

import AppProvider from "./components/AppProvider/AppProvider";

import Dashboard from "./containers/Dashboard";
import {
  ForgotPassword,
  Signin,
  Signup,
  SignupSurveyor,
  ResetPassword,
  Landing,
  BrowseGuest,
} from "./pages";
import { Header } from "./components";
// import { NotFound, BackendError } from './pages';
import CBSignup_titleCompanyAdmin from "./pages/Users/CBSignup_titleCompanyAdmin";
import CBSignup_titleCompany from "./pages/Users/CBSignup_titleCompany";
import CBSignupSurveyorAdmin from "./pages/Users/CBSignupSurveyorAdmin";
import CBSignupSurveyor from "./pages/Users/CBSignupSurveyor";

import ScrollToTop from "./ScrollToTop";
import registerServiceWorker from "./registerServiceWorker";

import JavascriptTimeAgo from "javascript-time-ago";

// The desired locales.
import en from "javascript-time-ago/locale/en";

// Initialize the desired locales.
JavascriptTimeAgo.locale(en);

const AuthRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (Auth.isAuthenticated()) {
        const token = localStorage.getItem("token");
        if (token && !token.length > 0) {
          return <Redirect to={{ pathname: "/signin" }} />;
        }

        // const {exp} = decode(token);

        return <Component {...props} />;
      } else {
        return <Redirect to={{ pathname: "/signin" }} />;
      }
    }}
  />
);

export default render(
  <AppProvider>
    <BrowserRouter>
      <ScrollToTop />
      <Switch>
        <Route exact path="/forgot" component={ForgotPassword} />
        <Route exact path="/signin" component={Signin} />
        <Route exact path="/reset/:token?" component={ResetPassword} />
        {/* <Route exact path="/signup" component={Signup} /> */}
        {/* <Route exact path="/signupsurveyor" component={SignupSurveyor} /> */}
        {/* <Route exact path="/landing" component={Landing} /> */}
        <Route exact path="/browseguest/:str" component={BrowseGuest} />
        <Route
          exact
          path="/callback/signup/2"
          component={CBSignup_titleCompanyAdmin}
        />
        <Route
          exact
          path="/callback/signup/3"
          component={CBSignup_titleCompany}
        />
        <Route
          exact
          path="/callback/signup/4"
          component={CBSignupSurveyorAdmin}
        />
        <Route exact path="/callback/signup/5" component={CBSignupSurveyor} />
        <AuthRoute path="/" component={Dashboard} />
        <Route exact path="/header" component={Header} />
        <Route path="/" component={Dashboard} />
      </Switch>
    </BrowserRouter>
  </AppProvider>,
  document.getElementById("root")
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js